<template>
  <section class="banner__area pt-20 pb-10">
    <div class="container">
      <div class="row">
        <div v-for="banner in bannerData" :key="banner.id" class="col-xl-4 col-lg-4 col-md-6">
          <div class="banner__item p-relative w-img mb-30">
            <div class="banner__img">
              <router-link href="/shop">
                <img :src="banner.bg_img" alt="banner-img" />
              </router-link>
            </div>
            <div class="banner__content">
              <h6>
                <router-link href="/shop">
                  <div v-html="banner.title"></div>
                </router-link>
              </h6>
              <p>{{ banner.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="js">
export default {
  name: 'BannerSection',
  data() {
    return {
      bannerData: [
        {
          id: 1,
          bg_img: require('@/assets/images/banner/banner-1.jpg'),
          title: 'Intelligent <br> New Touch Control',
          text: 'Discount 20% On Products'
        },
        {
          id: 2,
          bg_img: require('@/assets/images/banner/banner-2.jpg'),
          title: 'On-sale <br> Best Prices',
          text: 'Limited Time: Online Only!'
        },
        {
          id: 3,
          bg_img: require('@/assets/images/banner/banner-3.jpg'),
          title: 'Hot Sale <br> Super Laptops 2024',
          text: 'Free Shipping All Order'
        }
      ]
    };
  }
};
</script>

<style scoped>
/* Add any necessary custom styles here */
</style>
